import "core-js/modules/es.array.reverse.js";
var _class;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, observable, runInAction, makeObservable } from "mobx";
import filterOutUndefined from "../Core/filterOutUndefined";
import isDefined from "../Core/isDefined";
import TerriaError from "../Core/TerriaError";
import CommonStrata from "../Models/Definition/CommonStrata";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import StratumOrder from "../Models/Definition/StratumOrder";
import CatalogFunctionJobTraits from "../Traits/TraitsClasses/CatalogFunctionJobTraits";
import { InfoSectionTraits } from "../Traits/TraitsClasses/CatalogMemberTraits";
import AutoRefreshingMixin from "./AutoRefreshingMixin";
import CatalogMemberMixin from "./CatalogMemberMixin";
import GroupMixin from "./GroupMixin";
import MappableMixin from "./MappableMixin";
let FunctionJobStratum = (_class = class FunctionJobStratum extends LoadableStratum(CatalogFunctionJobTraits) {
  constructor(catalogFunctionJob) {
    super();
    this.catalogFunctionJob = catalogFunctionJob;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new FunctionJobStratum(model);
  }
  get shortReportSections() {
    if (this.catalogFunctionJob.logs.length === 0) return;
    return [{
      name: "Job Logs",
      content: this.catalogFunctionJob.logs.join("\n"),
      show: true
    }];
  }
  get shortReport() {
    let content;
    if (this.catalogFunctionJob.jobStatus === "inactive") {
      content = "Job is inactive";
    } else if (this.catalogFunctionJob.jobStatus === "running") {
      content = "Job is running...";
      // If job is running, but not polling - then warn user to not leave the page
      if (!this.catalogFunctionJob.refreshEnabled) {
        content += "\n\nPlease do not leave this page &mdash; or results may be lost";
      }
    } else if (this.catalogFunctionJob.jobStatus === "finished") {
      if (this.catalogFunctionJob.downloadedResults) {
        content = "Job is finished";
      } else {
        content = "Job is finished, downloading results...";
      }
    } else {
      content = "An error has occurred";
    }
    return content;
  }
  get description() {
    if (this.catalogFunctionJob.jobStatus === "finished") return "This is the result of invoking ".concat(this.catalogFunctionJob.name, " with the input parameters below.");
  }
  get info() {
    if (isDefined(this.catalogFunctionJob.parameters) && Object.values(this.catalogFunctionJob.parameters).length > 0) {
      const inputsSection = '<table class="cesium-infoBox-defaultTable">' + Object.keys(this.catalogFunctionJob.parameters).reduce((previousValue, key) => {
        return previousValue + "<tr>" + '<td style="vertical-align: middle">' + key + "</td>" + "<td>" + this.catalogFunctionJob.parameters[key] + "</td>" + "</tr>";
      }, "") + "</table>";
      return [createStratumInstance(InfoSectionTraits, {
        name: "Inputs",
        content: inputsSection
      })];
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "shortReportSections", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReportSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _class);
function CatalogFunctionJobMixin(Base) {
  var _class2, _descriptor;
  let CatalogFunctionJobMixin = (_class2 = class CatalogFunctionJobMixin extends GroupMixin(AutoRefreshingMixin(MappableMixin(CatalogMemberMixin(Base)))) {
    constructor() {
      super(...arguments);
      _defineProperty(this, "pollingForResults", false);
      _defineProperty(this, "downloadingResults", false);
      /**
       * Job result CatalogMembers - set from calling {@link CatalogFunctionJobMixin#downloadResults}
       */
      _initializerDefineProperty(this, "results", _descriptor, this);
      makeObservable(this);

      // Add FunctionJobStratum to strata
      runInAction(() => {
        this.strata.set(FunctionJobStratum.name, new FunctionJobStratum(this));
      });
    }

    /**
     *
     * @returns true for FINISHED, false for RUNNING (will then call pollForResults)
     */

    async invoke() {
      this.setTrait(CommonStrata.user, "jobStatus", "running");
      try {
        const finished = await runInAction(() => this._invoke());
        if (finished) {
          this.setTrait(CommonStrata.user, "jobStatus", "finished");
          await this.onJobFinish(true);
        } else {
          this.setTrait(CommonStrata.user, "refreshEnabled", true);
        }
      } catch (error) {
        this.setTrait(CommonStrata.user, "jobStatus", "error");
        // Note: we set raiseToUser argument as false here, as it is handled in CatalogFunctionMixin.submitJob()
        this.setOnError(error, false);
        throw error;
      }
    }
    get refreshInterval() {
      return 2;
    }
    /**
     * Called every refreshInterval
     *
     * @return true if job has finished, false otherwise
     */
    async pollForResults() {
      throw "pollForResults not implemented";
    }

    /**
     * This function adapts AutoRefreshMixin's refreshData with this Mixin's pollForResults - adding the boolean return value which triggers refresh disable
     */
    refreshData() {
      if (this.pollingForResults) {
        return;
      }
      this.pollingForResults = true;
      (async () => {
        try {
          const finished = await this.pollForResults();
          if (finished) {
            runInAction(() => {
              this.setTrait(CommonStrata.user, "jobStatus", "finished");
              this.setTrait(CommonStrata.user, "refreshEnabled", false);
            });
            await this.onJobFinish(true);
          }
          this.pollingForResults = false;
        } catch (error) {
          runInAction(() => {
            this.setTrait(CommonStrata.user, "jobStatus", "error");
            this.setTrait(CommonStrata.user, "refreshEnabled", false);
            this.setOnError(error);
          });
          this.pollingForResults = false;
        }
      })();
    }
    /**
     * This handles downloading job results, it can be triggered three ways:
     * - `_invoke` returns true {@link CatalogFunctionJobMixin#invoke}
     * - `pollForResults` returns true {@link CatalogFunctionJobMixin#refreshData}
     * - on `loadMetadata` if `jobStatus` is "finished", and `!downloadedResults`  {@link CatalogFunctionJobMixin#forceLoadMetadata}
     */
    async onJobFinish() {
      let addResultsToWorkbench = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.inWorkbench;
      // Download results when finished
      if (this.jobStatus === "finished" && !this.downloadedResults && !this.downloadingResults) {
        this.downloadingResults = true;
        this.results = (await this.downloadResults()) || [];
        this.results.forEach(result => {
          if (MappableMixin.isMixedInto(result)) result.setTrait(CommonStrata.user, "show", true);
          if (addResultsToWorkbench) this.terria.workbench.add(result).then(r => r.raiseError(this.terria));
          this.terria.addModel(result);
        });
        runInAction(() => {
          this.setTrait(CommonStrata.user, "members", filterOutUndefined(this.results.map(result => result.uniqueId)));
          this.setTrait(CommonStrata.user, "downloadedResults", true);
        });
        this.downloadingResults = false;
      }
    }
    /**
     * Called in {@link CatalogFunctionJobMixin#onJobFinish}
     * @returns catalog members to add to workbench
     */
    setOnError(error) {
      let raiseToUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const terriaError = TerriaError.from(error, {
        title: "Job failed",
        message: "An error has occurred while executing `".concat(this.name, "` job"),
        importance: -1
      });
      const errorMessage = terriaError.highestImportanceError.message;
      this.setTrait(CommonStrata.user, "logs", [...this.logs, errorMessage]);
      this.setTrait(CommonStrata.user, "shortReport", "".concat(this.typeName || this.type, " invocation failed. More details are available on the Info panel."));
      const errorInfo = createStratumInstance(InfoSectionTraits, {
        name: "".concat(this.typeName || this.type, " invocation failed."),
        content: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "The reason for failure is unknown."
      });
      const info = this.getTrait(CommonStrata.user, "info");
      if (isDefined(info)) {
        info.push(errorInfo);
      } else {
        this.setTrait(CommonStrata.user, "info", [errorInfo]);
      }
      if (raiseToUser) this.terria.raiseErrorToUser(terriaError);
    }
    get mapItems() {
      return [];
    }
    async forceLoadMapItems() {}
    async forceLoadMetadata() {
      if (this.jobStatus === "finished" && !this.downloadedResults) {
        await this.onJobFinish();
      }
    }
    async forceLoadMembers() {}
    get hasCatalogFunctionJobMixin() {
      return true;
    }
  }, _applyDecoratedDescriptor(_class2.prototype, "refreshData", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "refreshData"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "results", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "setOnError", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setOnError"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _class2);
  return CatalogFunctionJobMixin;
}
(function (_CatalogFunctionJobMixin2) {
  StratumOrder.addLoadStratum(FunctionJobStratum.name);
  function isMixedInto(model) {
    return model && model.hasCatalogFunctionJobMixin;
  }
  _CatalogFunctionJobMixin2.isMixedInto = isMixedInto;
})(CatalogFunctionJobMixin || (CatalogFunctionJobMixin = {}));
export default CatalogFunctionJobMixin;